<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-003"><span epub:type="pagebreak" id="page_12" title="12"></span>
<h1 class="pre_tit" epub:type="title"><span>Abbreviations</span></h1>
<div class="dev">
<div class="tableau" id="tab-001">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:3px;">
<col style="width:20%;"/>
<col style="padding:3px;"/>
</colgroup>
<tbody>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>ABD</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">D. N. Freedman (ed.), <i>The Anchor Bible Dictionary</i>. New York, 1992.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>ANET</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">J. B. Pritchard (ed.), <i>Ancient Near Eastern Texts Relating to the Old Testament</i>,20 3rd edn. Princeton, 1969.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">AV</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">The Authorized Version of the Bible, 1611.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>BA</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Biblical Archaeologist</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>BAR</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Biblical Archaeology Review</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">BDB</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">F. Brown, S. R. Driver and C. A. Briggs, <i>A Hebrew and English Lexicon of the Old Testament</i>. Oxford, 1907.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">BDF</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">F. Blass and A. Debrunner, <i>A Greek Grammar of the New Testament and Other Early Christian Literature</i>. Translated and revised by R. W. Funk. Chicago, 1961.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>BHS</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">K. Elliger and W. Rudolph, <i>Biblica Hebraica Stuttgartensia</i>, 3rd edn. Stuttgart, 1987.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>BJRL</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Bulletin of the John Rylands Library</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><span class="small">EVV</span></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">English versions.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">Gibson</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">J. C. L. Gibson, <i>Davidson’s Introductory Hebrew Grammar: Syntax</i>, 4th edn. Edinburgh, 1994.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">GKC</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">E. Kautzsch (ed.), <i>Gesenius’ Hebrew Grammar</i>. Revised by A. E. Cowley. Oxford, 1910.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">Joüon</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">P. Joüon, <i>A Grammar of Biblical Hebrew</i>. Translated and revised by T. Muraoka. Rome, 1991.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>JSOT</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Journal for the Study of the Old Testament</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">KB</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">L. Koehler and W. Baumgartner, <i>The Hebrew and Aramaic Lexicon of the Old Testament</i>. Translated by M. E. J. Richardson. Volume I. Leiden, 1994.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><span class="small">LXX</span></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">The Septuagint (Greek version of the Old Testament).</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><span class="small">MT</span></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">Masoretic Text.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><span class="small">NRSV</span></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>The New Revised Standard Version</i>, Anglicized Edition, 1989, 1995.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>OCD</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">N. G. L. Hammond and H. H. Scullard (eds.), <i>Oxford Classical Dictionary</i>, 2nd edn. Oxford, 1970.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><span epub:type="pagebreak" id="page_13" title="13"></span><i>OTS</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Oudtestamentische Studiën</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><span class="small">REB</span></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>The Revised English Bible</i>, 1989.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><span class="small">RSV</span></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>The Revised Standard Version</i>, 1952, 1971, 1973.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>SJT</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Scottish Journal of Theology</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>TDNT</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">G. Kittel and G. Friedrich, <i>Theological Dictionary of the New Testament</i>. Translated by G. W. Bromiley. 10 volumes. Grand Rapids, 1964-76.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>TrinJ</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Trinity Journal</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif"><i>VT</i></p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif"><i>Vetus Testamentum</i>.</p>
</td>
</tr>
<tr style="padding:3px; vertical-align:top;">
<td style="padding:3px;"><p class="txt_courant_justif">WO’C</p>
</td>
<td style="padding:3px;"><p class="txt_courant_justif">B. K. Waltke and M. O’Connor, <i>An Introduction to Biblical Hebrew Syntax</i>. Winona Lake, 1990.</p>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre4.vue?5959a59f